// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1oIfF","header":"PatientQuestionnaire_header__y8zm8","info":"PatientQuestionnaire_info__3Du_7"};